import type { BaseTableParams } from "@dashboardApi/apis/types";
import type { BaseTableResultItem, TableResult } from "@tanstack/react-table";

import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import type { SHARED_CONSTANTS_VERIFIED_DOMAIN_ERRORS } from "@lib/shared_constants";

import type { CustomDomain, CustomDomainType } from "../companiesCompanyIdCustomDomainsDomainTypeDomainId";

export interface CompaniesCompanyIdCustomDomainsParams extends BaseTableParams {
  /** the unique identifier for the company */
  companyId: string;
  /** the query object containing all the filters */
  query?: Partial<Record<string, string | string[]>>;
}

export interface CustomDomainTableItem extends BaseTableResultItem, CustomDomain {}

export type CustomDomainTableResult = TableResult<CustomDomainTableItem>;

export type CompaniesCompanyIdCustomDomainsResult = CustomDomainTableItem;

export interface PostCompaniesCompanyIdCustomDomainsProps {
  companyId: string;
  domain: string;
  domainType: CustomDomainType;
}

// error types

export type PostCompaniesCompanyIdCustomDomainsDomainAlreadyExistsError = FetchUserEncodedError<
  SHARED_CONSTANTS_VERIFIED_DOMAIN_ERRORS["ALREADY_EXISTS"],
  { domain: string }
>;

export type PostCompaniesCompanyIdCustomDomainsDomainLimitReachedError = FetchUserEncodedError<
  SHARED_CONSTANTS_VERIFIED_DOMAIN_ERRORS["LINK_SHORTENING_DOMAIN_LIMIT_REACHED"],
  { current: number; max: number }
>;

/** Union of the encoded errors returned by POST /companies/:company_id/custom_domains */
export type PostCompaniesCompanyIdCustomDomainsResultErrors =
  | PostCompaniesCompanyIdCustomDomainsDomainAlreadyExistsError
  | PostCompaniesCompanyIdCustomDomainsDomainLimitReachedError;

/** Typeguard that safely narrows a FetchRequestError into the POST endpoint's encoded error union */
export const isPostCompaniesCompanyIdCustomDomainsError = (
  error: FetchRequestError
): error is PostCompaniesCompanyIdCustomDomainsResultErrors => {
  return error instanceof FetchUserEncodedError;
};
